@if (showSpinner) {
<app-loader> </app-loader>
}
<main class="content-wrapper">
  <div class="container-fluid mb-4 pb-4 pt-2 pl-4 pr-4">
    <!-- Combined Header and Filter Section (Matching Attendance Management) -->
    <div class="combined-header-filter-section" >
      <!-- Header Content -->
      <div class="header-content">
        <div class="title-section">
          <div class="title-wrapper">
            <div class="title-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
              </svg>
            </div>
            <div class="title-text-container">
              <h1 class="main-title">Bulk Attendance Edit {{selectedMode}} print</h1>
              <p class="subtitle">Quickly update check-in and check-out for multiple employees</p>
            </div>
          </div>
        </div>

        <div class="action-buttons">
          <button type="button" class="modern-btn upload-btn" (click)="cancel()">
            <div class="btn-content">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
              <span>Back to Management</span>
            </div>
          </button>
        </div>
      </div>

      <!-- Filter Section (Always expanded here for utility) -->
      <div class="filter-content expanded">
        <div class="search-filters">
          <div class="filter-row filter-row-four">
            <div class="input-group">
              <label>Search Employee</label>
              <div class="input-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="M21 21l-4.35-4.35"></path>
                </svg>
                <input type="text" placeholder="Search by name..." [(ngModel)]="nameFilter"/>
              </div>
            </div>

            <div class="input-group">
              <label>Start Date</label>
              <div class="input-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                <input type="date" [value]="formatNative(startDateFilter)" (change)="applyStart($event)"
                  class="date-input" />
              </div>
            </div>

            <div class="input-group">
              <label>End Date</label>
              <div class="input-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                <input type="date" [value]="formatNative(endDateFilter)" (change)="applyEnd($event)"
                  class="date-input" />
              </div>
            </div>

            <div class="action-controls" style="margin-left: 0; align-self: flex-end; padding-bottom: 4px;">
              <button type="button" class="control-btn apply-btn" (click)="applyFilter()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                Record Fetch
              </button>
              <button type="button" class="control-btn reset-btn" (click)="resetFilter()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="1 4 1 10 7 10"></polyline>
                  <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
                </svg>
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Table Section (Matching Attendance Management styles) -->
    <div class="tablewidth mt-4">
      <table class="table-container shadow-sm" >
        <thead>
          <tr id="tableHead" class="tableHead">
            <th class="pl-3 heading-width">Name</th>
            <th class="text-center p-0">Date</th>
            <th class="text-center p-0">Check-In</th>
            <th class="text-center p-0">Check-Out</th>
            <th class="text-center p-0">Total Hours</th>
            <th class="text-center p-0 border-style">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let record of pagedData; let i = index" class="tableData tableDataBorder">
            <td class="pl-3 time-data name-back">
              <strong>{{ record.data[0].user.first_name }} {{ record.data[0].user.last_name }}</strong>
              <div class="text-muted" style="font-size: 11px;">ID: {{ record.data[0].user.attendance_user_id }}</div>
            </td>
            <td class="text-center">{{ parseDate(record.data[0].date) | date:'d MMM yyyy' }}</td>
            <td class="text-center p-0">
              <div *ngFor="let obj of record.data" class="d-flex justify-content-center py-2">
                <input type="time" class="form-control text-center" 
                       [(ngModel)]="obj.check_in" 
                       (ngModelChange)="calculateBulkWorkingHours(obj)"
                       style="width: 130px; border-radius: 8px;" />
              </div>
            </td>
            <td class="text-center p-0">
              <div *ngFor="let obj of record.data" class="d-flex justify-content-center py-2">
                <input type="time" class="form-control text-center" 
                       [(ngModel)]="obj.check_out" 
                       (ngModelChange)="calculateBulkWorkingHours(obj)"
                       style="width: 130px; border-radius: 8px;" />
              </div>
            </td>
            <td class="text-center p-0">
              <div *ngFor="let obj of record.data" class="d-flex justify-content-center py-2">
                <input type="text" class="form-control text-center" 
                       [(ngModel)]="obj.total_hours" 
                       readonly
                       style="width: 90px; border-radius: 8px;" />
              </div>
            </td>
            <td class="text-center p-0">
              <div *ngFor="let obj of record.data; let objIndex = index" class="d-flex justify-content-center py-2">
                <button class="btn btn-link text-danger p-0" title="Delete Record" (click)="deleteRecord(obj, i, objIndex)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="pagedData.length === 0">
            <td colspan="6" class="text-center py-5">
              <div class="no-data-msg">No attendance records found for the selected filters.</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Bulk Update Footer (Matching Attendance Management theme) -->
    <div class="bulk-footer shadow-sm p-4 mt-4" *ngIf="pagedData.length > 0" >
      <div class="row">
        <div class="col-md-12">
          <h5 class="section-title">Complete Bulk Update</h5>
          <div class="form-group mb-3">
            <label>Reason for bulk update <span class="text-danger">*</span></label>
            <textarea class="form-control" rows="3" placeholder="Enter reason (Minimum 50 characters)..." [(ngModel)]="bulkEditReason"></textarea>
            <div class="d-flex justify-content-between mt-1">
              <small [ngClass]="{'text-danger': bulkEditReason.length < 50, 'text-success': bulkEditReason.length >= 50}">
                Currently {{ bulkEditReason.length }} characters.
              </small>
              <small class="text-muted">Min 50 characters required</small>
            </div>
          </div>
          <div class="d-flex justify-content-end action-btns">
            <button class="btn btn-secondary mr-2 px-4" (click)="cancel()">Cancel</button>
            <button class="btn btn-primary px-4" [disabled]="bulkEditReason.length < 50 || showSpinner" (click)="saveBulkEdit()">
              <i class="fa fa-spinner fa-spin mr-1" *ngIf="showSpinner"></i> Save All Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
